// @flow
import { pickBy } from 'lodash'

export const getArticles = (state: Object, assetId: string): Object => {
  return pickBy(state.articles.resources, (article) => article.asset === assetId)
}
